import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  Stack,
} from '@mui/material';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';

function CancelDonation() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #003366 0%, #001a33 100%)',
        py: 6,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={8}
          sx={{
            p: 5,
            borderRadius: 3,
            textAlign: 'center',
            background: '#fff',
          }}
        >
          <VolunteerActivismIcon
            sx={{
              fontSize: 80,
              color: '#003366',
              mb: 3,
            }}
          />

          <Typography
            variant="h4"
            sx={{
              color: '#003366',
              fontWeight: 700,
              mb: 2,
            }}
          >
            No Problem!
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              lineHeight: 1.8,
              mb: 2,
            }}
          >
            We understand — there are many ways to support our mission beyond donations.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              lineHeight: 1.8,
              mb: 4,
            }}
          >
            Whether it's spreading the word, volunteering your time, or simply being a safe 
            driver on Texas roads, every bit helps keep our community safe.
          </Typography>

          <Box
            sx={{
              bgcolor: 'rgba(0,51,102,0.05)',
              borderRadius: 2,
              p: 3,
              mb: 4,
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                color: '#003366',
                fontWeight: 600,
                mb: 1,
              }}
            >
              Other Ways to Help
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                lineHeight: 1.7,
              }}
            >
              • Share our mission on social media<br />
              • Consider becoming a volunteer Ranger<br />
              • Tell friends and family about our free roadside assistance<br />
              • Follow us to stay updated on our work
            </Typography>
          </Box>

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent="center"
          >
            <Button
              href="/"
              variant="contained"
              startIcon={<HomeIcon />}
              sx={{
                bgcolor: '#003366',
                px: 3,
                py: 1.5,
                '&:hover': {
                  bgcolor: '#002244',
                },
              }}
            >
              Return Home
            </Button>
            <Button
              href="/about"
              variant="outlined"
              startIcon={<InfoIcon />}
              sx={{
                borderColor: '#003366',
                color: '#003366',
                px: 3,
                py: 1.5,
                '&:hover': {
                  borderColor: '#002244',
                  bgcolor: 'rgba(0,51,102,0.05)',
                },
              }}
            >
              Learn More About Us
            </Button>
          </Stack>
        </Paper>

        {/* Still want to donate */}
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography
            variant="body2"
            sx={{ color: 'rgba(255,255,255,0.7)', mb: 2 }}
          >
            Changed your mind?
          </Typography>
          <Button
            href="https://www.paypal.com/donate/?hosted_button_id=DGZ6BNXSWDCAC&return=https://www.highwayrangers.com/donated&cancel_return=https://www.highwayrangers.com/canceldonation"
            target="_blank"
            variant="contained"
            sx={{
              bgcolor: '#ffc107',
              color: '#003366',
              fontWeight: 700,
              '&:hover': {
                bgcolor: '#ffca28',
              },
            }}
          >
            Donate Now
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default CancelDonation;
